import { service } from '../axios';
/**
 * 添加课程耗材
 */
export function addCourseConsumable(data) {
    return service({
        url: '/labCourseConsumable/addConsumable',
        method: 'post',
        data
    });
}
/**
 * 批量添加课程耗材
 */
export function addBatchCourseConsumable(data) {
    return service({
        url: '/labCourseConsumable/addBatchConsumable',
        method: 'post',
        data
    });
}
/**
 * 删除课程耗材
 */
export function removeCourseConsumable(data) {
    return service({
        url: '/labCourseConsumable/removeConsumable',
        method: 'post',
        data
    });
}
export function listCourseConsumables(experimentCode) {
    return service({
        url: '/labCourseConsumable/listConsumables',
        method: 'get',
        params: {
            experimentCode
        }
    });
}
export function listConsumablesByCatalogId(catalogId) {
    return service({
        url: '/labCourseConsumable/listConsumablesByCatalogId',
        method: 'get',
        params: {
            catalogId
        }
    });
}
export function startCourseExecutionOnce(data) {
    return service({
        url: '/courseSchedule/startCourseExecutionOnce',
        method: 'post',
        data
    });
}
